<template lang="pug">
.twitch__error
  p.twitch__error-text(v-html="getErrorText" )
  .twitch__error-link(@click="reloadPage") {{ $t("twitch.errors.button") }}

</template>

<script>
export default {
  name: "TwitchError",

  props: {
    errorCode: {
      type: String,
      default: "",
    },
  },

  computed: {
    getErrorText() {
      let error_code = this.errorCode === "13702" ? 13702 : "default";
      return this.$t(`twitch.errors.${error_code}`);
    },
  },

  methods: {
    reloadPage() {
      document.location = document.location.href.split("?")[0];
    },
  },
};
</script>
